export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10577.5c6f321e.jpg";